import { Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { useTheme } from '@emotion/react';
import { useTranslation } from 'react-i18next';

import { Image } from 'src/components/image';
import { BRANDFOLDER_BASE_URL } from 'src/api/concierge';
import { getTheme } from 'src/utils/get-theme';
import { useGetCurrentUser } from 'src/features/user/hooks/use-get-current-user';
import { CopyButton } from 'src/components/copy-button';

export const ReferralCard: FC = () => {
    const { palette, breakpoints, transitions } = useTheme();
    const {
        i18n: { language },
    } = useTranslation();

    const { t } = useTranslation();
    const { isHosTheme } = getTheme();
    const { data } = useGetCurrentUser();

    return (
        <Stack
            css={{
                textDecoration: 'none',
            }}
        >
            <Stack
                padding="24px"
                height={{ xs: '180px', md: '220px', lg: '260px' }}
                position="relative"
                onClick={() =>
                    window.open(
                        isHosTheme
                            ? 'https://www.houseofsocial.com/refer-your-mates/'
                            : `https://www.vitastudent.com/${language}/vita-collective/`,
                        '_blank'
                    )
                }
                css={{
                    cursor: 'pointer',

                    ':hover *.PromotionCardInner__preview img': {
                        transform: 'scale(1.15)',
                    },
                }}
            >
                <Image
                    alt="Referral Program"
                    src={
                        isHosTheme
                            ? `${BRANDFOLDER_BASE_URL}/2EZAWJN8/at/tfnp9cp8fhxg7n5nxgx6kp4z/HoS106_Referrals_Extended_Campaign_2000x800_myaccount.png`
                            : `${BRANDFOLDER_BASE_URL}/2EZAWJN8/at/vrrgkrtf7vjnjq758ftmwk9m/VS2526_073_New_Referral_2000x800_myaccount.png`
                    }
                    className="PromotionCardInner__preview"
                    css={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',

                        img: {
                            transition: transitions.create('all'),
                        },
                    }}
                />
            </Stack>
            <Stack
                padding={{ xs: '16px 0' }}
                flexGrow={1}
                css={{
                    margin: '0 16px',
                    borderBottom: `1px solid ${palette.divider}`,
                    [breakpoints.up('md')]: {
                        margin: '0',
                    },
                }}
            >
                <Typography variant="h4" paddingBottom="4px" color={palette.text.secondary}>
                    {t('home_exclusive-offers_referrals_subtitle')}
                </Typography>

                <Typography variant="h2" color={palette.text.primary} paddingBottom="16px">
                    {isHosTheme
                        ? t('home_exclusive-offers_referrals_title_hos')
                        : t('home_exclusive-offers_referrals_title_vs')}
                </Typography>

                <span
                    css={{
                        width: '60px',
                        borderBottom: `1px solid ${palette.common.black}`,
                        display: 'block',
                    }}
                />

                <Typography
                    variant="body1"
                    color={palette.text.primary}
                    paddingTop="16px"
                    paddingBottom="16px"
                    display="flex"
                    alignItems="center"
                    gap={1}
                >
                    {t('home_exclusive-offers_referrals_content')}
                    <strong>{data?.referral_code}</strong>
                    {data?.referral_code && <CopyButton text={data.referral_code} />}
                </Typography>
            </Stack>
        </Stack>
    );
};
